import React from "react";
import { AutoRegistrationProvider } from "../../components/AutoRegistration/context/AutoRegistrationProvider";
import { AutoRegistrationComponent } from "../../components/AutoRegistration";

export const AutoRegistration = () => (
  <AutoRegistrationProvider>
    <AutoRegistrationComponent />
  </AutoRegistrationProvider>
);
